export default __webpack_public_path__ + "static/media/graignes21.97c3f62d.jpg";